<script>
  import {
    containerW,
    container,
    windowW,
    containerH,
  } from "../stores/dimensions";
</script>

<svelte:window bind:innerWidth={$windowW} />

<div
  class="container relative w-full h-full max-w-4xl overflow-y-scroll prose transition-all bg-white rounded-md shadow"
  bind:offsetWidth={$containerW}
  bind:offsetHeight={$containerH}
  bind:this={$container}
>
  <slot />
</div>

<style>
  /* moving the 95vh height to the wrapper so the dropdowns can overflow properly */
  .container {
    /* max-height: 100vh; */
  }
</style>
